module.exports = __webpack_public_path__ + "img/19_71.aafc3977.png";